import {DataObjectId} from 'yougile-model'
import {rightPanelStore} from '../right-panel'
import {useGroupChatStore} from './group-chat-store'

interface Handlers {
  toggle: (userIds: DataObjectId[]) => void
  onChange: (value: string) => void
  cancel: () => boolean
  save: () => void
}

export const useHandlers = (): Handlers => {
  const [, store] = useGroupChatStore()

  const toggle = (userIds: DataObjectId[]): void => {
    store.toggleUser(userIds)
  }

  const onChange = (value: string): void => {
    store.onChange(value)
  }

  const cancel = (): boolean => {
    rightPanelStore.setGroupChatEdit(false)
    return true
  }

  const save = (): void => {
    store.save(cancel)
  }

  return {toggle, onChange, cancel, save}
}
